import { ResponseBase } from '../response-base.model';
export class AddEvaluacionResponse extends ResponseBase {
    id: number;
    nombreDepa: string;
    descripcion: string;
    habilitado: boolean;
    codigoE: string;
}